import { exists as t } from "../runtime.js";
const m = {
  MarriageCertificate: "MARRIAGE_CERTIFICATE"
};
function c(e) {
  return !0;
}
function d(e) {
  return o(e);
}
function o(e, n) {
  return e == null ? e : {
    documentType: t(e, "documentType") ? e.documentType : void 0,
    documentData: t(e, "documentData") ? e.documentData : void 0,
    documentMimeType: t(e, "documentMimeType") ? e.documentMimeType : void 0,
    documentId: t(e, "documentId") ? e.documentId : void 0
  };
}
function i(e) {
  if (e !== void 0)
    return e === null ? null : {
      documentType: e.documentType,
      documentData: e.documentData,
      documentMimeType: e.documentMimeType,
      documentId: e.documentId
    };
}
export {
  m as CoAppDocumentDocumentTypeEnum,
  d as CoAppDocumentFromJSON,
  o as CoAppDocumentFromJSONTyped,
  i as CoAppDocumentToJSON,
  c as instanceOfCoAppDocument
};
//# sourceMappingURL=CoAppDocument.js.map
